import { render, staticRenderFns } from "./SettingsScreen.vue?vue&type=template&id=05fdea80&scoped=true"
import script from "./SettingsScreen.vue?vue&type=script&lang=js"
export * from "./SettingsScreen.vue?vue&type=script&lang=js"
import style0 from "./SettingsScreen.vue?vue&type=style&index=0&id=05fdea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fdea80",
  null
  
)

export default component.exports